<template>
  <div>

    <!-- --------- Device Information ---------- -->
    <b-row class="border-bottom mb-2">
      <b-col>
        <h3 class="mb-0">
          Device Details
        </h3>
        <small class="text-muted">
          Enter details that will enable you or your team to indentify the device
        </small>
      </b-col>
    </b-row>

    <!-- Device Name -->
    <b-row>
      <b-col>
        <b-form-group
          label="Device Name"
          label-for="deviceName"
        >
          <validation-provider
            #default="{ errors }"
            name="Device Name"
            rules="required"
          >
            <b-form-input
              id="deviceName"
              v-model="newDevice.deviceInfo.name"
              :state="newDevice.deviceInfo.name.length > 0 "
              placeholder="A name for your hardware device"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>

      <!-- S/N -->
      <b-col>
        <b-form-group
          label="Manufacturer Serial Number"
          label-for="manufacturerSerialNumber"
        >
          <b-form-input
            id="manufacturerSerialNumber"
            v-model="newDevice.deviceInfo.deviceManufacturerSerialNumber"
            placeholder="A serial number for a hardware device is often on the bottom or back of the device."
          />
        </b-form-group>
      </b-col>
    </b-row>
    <!----------- Tags
    <b-row>
      <b-col>
        <b-form-group
          label="Tags"
          label-for="tags"
        >
          <v-select
            v-model="newDevice.deviceInfo.tags"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            multiple
            taggable
            push-tags
            placeholder="Add tags"
            label="name"
            :options="tags"
          />
          {{ tags }}
          {{ newDevice.deviceInfo.tags }}
        </b-form-group>
      </b-col>
    </b-row>
    ------------>

  </div>
</template>

<script>
/* eslint-disable prefer-destructuring */
/* eslint-disable no-unused-vars */
import {
  BRow, BCol, BFormGroup, BFormInput, BFormCheckbox,
} from 'bootstrap-vue'
import { API } from 'aws-amplify'
import { ValidationProvider } from 'vee-validate'
// import vSelect from 'vue-select'
import * as queries from '../../../graphql/queries'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    ValidationProvider,
    // vSelect,
  },
  props: {
    newDevice: {
      type: Object,
      required: true,
    },
    tags: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      changeId: true,
    }
  },
  watch: {
    tags: {
      deep: true,
      handler(newVal) {
        this.tags = newVal
      },
    },
  },
}

</script>

<style>

</style>
